/*
  Gives every theme button the landing's trimmings: the arrow glyph from
  wecanflyagency.com and the pair of blurred blooms behind the label. The
  landing renders both from snippets/landing-button.liquid; the theme's
  buttons are written inline across two dozen sections, so they are added
  here instead of editing each one.

  Skipped: tertiary links, Shopify's own dynamic-checkout button (it is
  re-rendered by their script and would lose the nodes), and anything opting
  out with data-no-arrow.
*/
(function () {
  const SELECTOR = [
    'a.button',
    'button.button',
    '.shopify-challenge__button',
    '.shopify-payment-button__button--unbranded',
  ].join(',');

  const SKIP = [
    '.button--tertiary',
    '.skip-to-content-link',
    '.cart-remove-button',
    'cart-remove-button .button',
    '[data-no-arrow]',
  ].join(',');

  const ARROW =
    '<svg class="btn__icon" viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" ' +
    'd="M10.5 1.5H2V2.5H8.79292L2.14648 9.14644L2.85359 9.85355L9.5 3.20714V10H10.5V1.5Z" ' +
    'fill="currentColor"/></svg>';

  function decorate(button) {
    if (button.matches(SKIP)) return;
    /* Shopify re-renders the dynamic-checkout button's contents on every
       variant change, which wipes the nodes without replacing the button
       itself — so a button that lost its arrow is decorated again. */
    if (button.dataset.brandButton === 'true' && button.querySelector('.btn__icon')) return;
    button.dataset.brandButton = 'true';

    const icon = document.createElement('span');
    icon.className = 'btn__icon-box';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = ARROW;
    button.appendChild(icon);

    const glow = document.createElement('span');
    glow.className = 'btn__glow';
    glow.setAttribute('aria-hidden', 'true');
    glow.innerHTML = '<span class="btn__glow-a"></span><span class="btn__glow-b"></span>';
    button.appendChild(glow);
  }

  function run(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(decorate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else {
    run();
  }

  /* Cart updates, quick-add and the Section Rendering API all replace markup
     after load, so anything that arrives later is decorated too. */
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(SELECTOR)) decorate(node);
        if (node.querySelectorAll) run(node);
      });

      /* Contents swapped inside a button that is already on the page. */
      const host = mutation.target.closest && mutation.target.closest(SELECTOR);
      if (host) decorate(host);
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
